export const regexWebsite = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{1,6})(\/[\w]*)*$/i;
export const regexZipCode = /^[0-9]{5}(?:-[0-9]{4})?$/;
export const regexPOBox = /^\s*(P\.?\s*O\.?\s*|POST\s*OFFICE\s*|POSTAL\s*)\s*BOX\s*\d*/i;
